<template>

<form class="my-2 my-lg-0 mr-auto" @submit.prevent='searchPage'>
    <div class="search-form">

        <div class="siwrap">
            <input v-model.trim='srch' @keyup='autocomplete' 
                 class="form-control" type="search" 
                 placeholder="Search now..." aria-label="Search">
            <button @click='reset' class="search-btn" type="button" v-if='srch.length'>
                <span class="material-icons-round">&#xe5cd;</span>
            </button>

            <div class='ac-results' v-if='results' v-show='showAC'>

                <div v-for='res in results' @click='open( res.s )' class='ac-row'>
                    {{ res.n }}
                </div>

                <div v-if='!results.length' class='ac-row'>
                    No results found
                </div>

            </div>
        </div>

        <button @click='searchPage' class="btn btn-search" type="button">
            <span class="icon icon-magnifier"></span>
        </button>
        
    </div>
</form>

</template>

<script>
    export default {

        mounted() {

        },

        created() {
           
        },

        data() {
            return {
                isReady : false,
                results : [],
                showAC  : false,
                srch    : '',
                minLen  : 3,

            }
        },

        methods : {
            reset() {
                this.showAC = false;
                this.srch = '';
            },

            autocomplete : _.debounce( function() {
                if( this.srch.length < this.minLen ) {
                    this.showAC = false;
                    return;
                }
                
                var me = this;

                me.ajax.call('ac:get', { s : this.srch } , (r) => {
                    
                    if( r.status == 'success' ) {

                        me.results = r.data;
                        me.showAC = true;

                    }

                })

            }, 350),


            searchPage() {
                location.href = '/search/' + this.srch;
            },

            open( slug ) {
                location.href = '/onlyfans-models/' + slug;
            }
        }   

    }
</script>
<style>
    
    /*.ac-results {
        position: absolute;
        width: 100%;
        background: #fff;
        padding: 0;
        cursor: pointer;
        border : 1px solid #fff;
        border-radius: 6px;
        color: #373737;
        overflow: hidden;
    }

    .ac-row {
        padding: 4px 10px;
    }

    .ac-row:hover {
        background: #f4f4f4;
    }*/


</style>